<template>
  <div class="form p-12" style="background-color:#fff;">
    <div>
      To facilitate communications between ship and shore during cargo operation, please acknowledge receipt of this
      walkie talkie from Jurong Port Universal Terminal Pte. Ltd. This walkie talkie shall be returned to JPUTPL upon
      completion of the operation.
    </div>
    <div class="mt-4 flex items-center">
      <span class="mr-4" style="font-size: 12px"><span style="color:red">*</span>Transceiver Serial Number:</span>
      <div>
        <el-input v-model="aftformReceiptWalkieTalkie.transceiverNum"
          :disabled="disabled || ($store.state.userInfo.role != '11' && $store.state.userInfo.role != '3')"
          size="mini"></el-input>
      </div>
    </div>
    <div class="mt-4">
      Kindly acknowledge receipt of the above walkie talkie for return to Jurong Port Universal Terminal Pte. Ltd.
    </div>
    <!-- 签名 -->
    <div class="mt-4 f-500" style="color:#4C565C ">
      Signature
    </div>
    <div class="flex flex-wrap w-full xl:w-1/2 mt-4 justify-between">
      <div class="w-full sm:w-1/2 ">
        <div class="f-600">Terminal Representative</div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Name:</span>
          <span class="ml-2">{{ sign.terminal.name }}</span>
        </div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Date and Time:</span>
          <span class="ml-2">{{ sign.terminal.createTime }}</span>
        </div>
        <div class="mt-4 f-600 flex" style="font-size: 12px">
          <span>Signature:</span>
          <img v-if="sign.terminal.eSignature" :src="sign.terminal.eSignature" class="ml-2" style="width: 100px;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { saveOrUpdateForms, selectFromById } from "@/services/form";

export default {
  name: 'ReceiptOfWalkie',
  props: {
    disabled: {
      type: Boolean
    },
    sign: {
      type: Object
    }
  },
  data() {
    return {
      aftformReceiptWalkieTalkie: {},
      formType: '',
      params: {}
    }
  },
  mounted() {
    if (this.$route.query) {
      this.params = this.$route.query
      this.getDetail()
    }
  },
  methods: {
    save() {
      const data = {
        aftformReceiptWalkieTalkie: {
          ...this.aftformReceiptWalkieTalkie,
          nominationId: this.params.id,
        },
        nominationId: this.params.id,
        formType: this.formType
      }
      saveOrUpdateForms(data).then(res => {
        this.getDetail()
        this.$emit('update')
        this.$message.success('Save Success')
      }).catch(() => {
        this.$emit('update')
      })
    },
    getDetail() {
      selectFromById({
        nId: this.params.id,
        fId: 15
      }).then(res => {
        this.aftformReceiptWalkieTalkie = res.data.aftformReceiptWalkieTalkie
        this.formType = res.data.formType
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  font-size: 14px;
  color: #82889C;
}
</style>
